import { render, staticRenderFns } from "./SCircuitApproval.vue?vue&type=template&id=db7d08c4"
import script from "./SCircuitApproval.vue?vue&type=script&lang=js"
export * from "./SCircuitApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports